import { useEffect, useRef, useState } from "react";
import styled from "styled-components";

const RevealBox = styled.div`
  opacity: 0;
  transform: translateY(${(props) => props.$y}px);
  transition: opacity 0.7s ease, transform 0.7s ease;
  transition-delay: ${(props) => props.$delay}ms;

  &[data-visible="true"] {
    opacity: 1;
    transform: translateY(0);
  }

  @media (prefers-reduced-motion: reduce) {
    opacity: 1;
    transform: none;
  }
`;

const Reveal = ({ children, y = 28, delay = 0, className }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(el);
        }
      },
      { threshold: 0.15, rootMargin: "0px 0px -40px 0px" }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <RevealBox
      ref={ref}
      $y={y}
      $delay={delay}
      data-visible={visible}
      className={className}
    >
      {children}
    </RevealBox>
  );
};

export default Reveal;
